import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { LANG_KEY } from '../../../helpers/i18n';
import Styles from './styles.module.scss';

const LangSwitcher = ({ isCabinet = false }) => {
    const { i18n } = useTranslation();
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    const locale = i18n.language?.startsWith('ru') ? 'ru' : 'en';
    const currentLabel = locale === 'ru' ? 'RU' : 'EN';

    const handleSelect = (lang) => {
        i18n.changeLanguage(lang);
        localStorage.setItem(LANG_KEY, lang);
        setOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div
            className={`${Styles.langSwitcher} ${isCabinet ? Styles.cabinet : ""}`}
            ref={ref}
        >
            <button
                type="button"
                className={Styles.langButton}
                onClick={() => setOpen((prev) => !prev)}
            >
                {currentLabel}
                <span className={Styles.arrow} />
            </button>

            {open && (
                <div className={Styles.dropdown}>
                    <button
                        type="button"
                        className={`${Styles.option} ${locale === 'en' ? Styles.active : ''}`}
                        onClick={() => handleSelect('en')}
                    >
                        EN
                    </button>

                    <button
                        type="button"
                        className={`${Styles.option} ${locale === 'ru' ? Styles.active : ''}`}
                        onClick={() => handleSelect('ru')}
                    >
                        RU
                    </button>
                </div>
            )}
        </div>
    );
};

export default LangSwitcher;


